// Interpolate by distance along the displayed polyline, never through a corner.
export function interpolateRoutePath(path, fraction) {
 if(!path?.length)return null;
 const f=Math.min(1,Math.max(0,Number.isFinite(fraction)?fraction:0));
 const delta=(a,b)=>((b-a+540)%360)-180;
 const lengths=path.slice(1).map((p,i)=>Math.hypot(p.latitude-path[i].latitude,delta(path[i].longitude,p.longitude)*Math.cos((p.latitude+path[i].latitude)*Math.PI/360)));
 const total=lengths.reduce((a,b)=>a+b,0);let remaining=f*total;const prefix=[path[0]];
 for(let i=0;i<lengths.length;i++){const length=lengths[i];if(remaining>length&&i<lengths.length-1){remaining-=length;prefix.push(path[i+1]);continue;}
  const part=length?Math.min(1,remaining/length):1,a=path[i],b=path[i+1];const point={latitude:a.latitude+(b.latitude-a.latitude)*part,longitude:((a.longitude+delta(a.longitude,b.longitude)*part+540)%360)-180};
  return {point,path:[...prefix,point]};}
 return {point:path[0],path:prefix};
}
